<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">凭证汇总表</span>
		</div>
		<div class="margin-right-left margin-top">
			<account-date-range-choose v-model="dateRange"/>
			<Button color="primary" icon="fa fa-search" :loading="loading" @click="loadData" class="margin-left">查询</Button>
		</div>
		<div class="h-panel-body">
			<div class="summary-header" v-if="summaryInfo">
				<span>凭证总张数: {{summaryInfo.totalCount}}张</span>
				<span class="margin-left">附件总张数: {{summaryInfo.attachmentCount || 0}}张</span>
			</div>
			<table class="header">
				<tr>
					<td style="width: 120px">科目编码</td>
					<td style="width: 200px">科目名称</td>
					<td align="right" style="width: 150px">借方金额</td>
					<td align="right" style="width: 150px">贷方金额</td>
				</tr>
			</table>
			<table v-if="!datas.length">
				<tr>
					<td colspan="4" class="text-center padding">暂无数据</td>
				</tr>
			</table>
			<table class="body-table" v-else>
				<tr v-for="item in datas" :key="item.subjectCode">
					<td style="width: 120px">{{item.subjectCode}}</td>
					<td style="width: 200px">{{item.subjectName}}</td>
					<td align="right" style="width: 150px">{{item.debitAmount|numFormat}}</td>
					<td align="right" style="width: 150px">{{item.creditAmount|numFormat}}</td>
				</tr>
				<tr class="total-row">
					<td colspan="2">合计</td>
					<td align="right">{{totalDebit|numFormat}}</td>
					<td align="right">{{totalCredit|numFormat}}</td>
				</tr>
			</table>
		</div>
	</app-content>
</template>

<script>
	import {mapState} from 'vuex'
	import AccountDateRangeChoose from '@/components/AccountDateRangeChoose.vue';

	export default {
		name: "VoucherSummary",
		components: {AccountDateRangeChoose},
		data() {
			return {
				datas: [],
				dateRange: null,
				loading: false,
				summaryInfo: null
			};
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			totalDebit() {
				return this.datas.reduce((sum, item) => sum + (item.debitAmount || 0), 0);
			},
			totalCredit() {
				return this.datas.reduce((sum, item) => sum + (item.creditAmount || 0), 0);
			}
		},
		watch: {
			dateRange: {
				handler(val) {
					if (val && val.startDate && val.endDate) {
						this.loadData();
					}
				},
				deep: true
			}
		},
		methods: {
			loadData() {
				if (!this.dateRange) return;
				this.loading = true;
				this.$api.voucher.voucherSummary({
					startYear: this.dateRange.startYear,
					startMonth: this.dateRange.startMonth,
					endYear: this.dateRange.endYear,
					endMonth: this.dateRange.endMonth
				}).then(({data}) => {
					this.datas = data.items || [];
					this.summaryInfo = {
						totalCount: data.totalCount || 0,
						attachmentCount: data.attachmentCount || 0
					};
				}).finally(() => {
					this.loading = false;
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.h-panel-body {
		table {
			width: 100%;
			border-collapse: collapse;

			td {
				padding: 8px;
				border: 1px solid #e0e0e0;
			}

			&.header {
				background-color: @primary-color;
				color: white;
				
				td {
					border-color: @primary-color;
				}
			}

			&.body-table {
				tr:hover {
					background-color: #f5f5f5;
				}

				.total-row {
					background-color: #f0f0f0;
					font-weight: bold;
				}
			}
		}

		.summary-header {
			padding: 10px 0;
			font-size: 13px;
			color: #666;
		}
	}
</style>
